import { Stretch, Vertical } from "gls/lib";
import { FC } from "react";
import { keyframes, stylesheet } from "typestyle";

interface LoaderProps {
  message?: string;
}

export const Loader: FC<LoaderProps> = ({ message }) => {
  return (
    <Stretch
      verticalAlign="center"
      horizontalAlign="center"
      data-testid="loader"
    >
      <Vertical>
        <div className={classNames.loader} />

        {message && <label className={classNames.text}>{message}</label>}
      </Vertical>
    </Stretch>
  );
};

const spin = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" },
});

const classNames = stylesheet({
  container: {
    display: "flex",
    alignItems: "center",
  },
  text: {
    marginTop: 10,
  },
  loader: {
    border: "3px solid #f3f3f3",
    borderTop: "3px solid #3498db",
    borderRadius: "50%",
    width: 20,
    height: 20,
    animation: `${spin} 2s linear infinite`,
  },
});
